import React from 'react'; // eslint-disable-line
import CaptionTooltip from '../../components/common/CaptionTooltip';
import CloseModal from '../../components/svg/CloseX2';
import AlertLoader from '../alerts/AlertLoader';

export default class LargeModal extends React.Component {
    constructor(props) {
        super(props);
        this.closeDialog = this.closeDialog.bind(this);
    }

    closeDialog() {
        if (this.props.close) {
            this.props.close();
        }
    }

    render() {
        return (
            <div className={`dialog-overlay ${this.props.visible ? 'dialog-show' : 'dialog-hide'}`}>
                <div data-qa={`large-modal ${this.props.dataqa}`} className={`large-modal dialog-content ${this.props.class}`}>
                    <div className="modal-header">
                        <CaptionTooltip tooltipText="Close">
                            {/* eslint-disable-next-line */}
                            <a
                                aria-label="Close"
                                data-qa="modal-close"
                                className="close-dialog"
                                onClick={this.closeDialog}
                            >
                                <CloseModal />
                            </a>
                        </CaptionTooltip>
                        <h3
                            data-qa="modal-header"
                        >
                            {this.props.title}
                        </h3>
                    </div>
                    <div className="large-modal-height-container">
                        {this.props.alertView && <AlertLoader viewName={this.props.alertView} />}
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}
